import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { userChannelList, changeVoucherPayTurnon } from '@/api/gmtool/packageCode';
import { gmTool, serchSelect } from "@/mixins/index";
export default {
  mixins: [gmTool, serchSelect],
  data: function data() {
    return {
      paramsData: {
        server_list: [],
        channel_list: [],
        turnon: true
      },
      dialogShow: false,
      channelList: [],
      rules: {
        server_list: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        channel_list: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        turnon: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }]
      },
      issubmit: false,
      isdisabled: false,
      type: 0
    };
  },
  created: function created() {},
  methods: {
    open: function open() {
      this.dialogShow = true;
      this.paramsData.is_prod = this.severlist.length ? this.severlist[0].value : '';
      this.getChannel();
      this.getserverList();
    },
    getChannel: function getChannel() {
      var _this = this;

      userChannelList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.channelList = res.data;
        }
      });
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.paramsData.server_list = [];
                _context.next = 3;
                return _this2.getserverList();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData() {
      this.paramsData = {
        server_list: [],
        channel_list: [],
        turnon: true
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.issubmit = true;
          var data = JSON.parse(JSON.stringify(_this3.paramsData));
          data.server_list = data.server_list.join(",");
          data.channel_list = data.channel_list.join(",");
          changeVoucherPayTurnon(data).then(function (res) {
            if (res.result == 1) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('change');
            } else {
              _this3.$message.error(res.reason);
            }
          }).finally(function () {
            _this3.issubmit = false;
          });
        }
      });
    }
  }
};